"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _order = require("@/api/order");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'agreeToReturn',
  props: {
    refundInfo: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      listLoading: false,
      addressList: [],
      refundAddrId: '',
      loading: false
    };
  },
  mounted: function mounted() {
    this.refundAddrId = this.refundInfo.merchantAddressId;
    this.getList();
  },
  methods: {
    //确定提交
    handleSubmit: function handleSubmit() {
      this.submit();
    },
    // 提交方法
    submit: function submit() {
      var _this = this;
      if (!this.refundAddrId) {
        return this.$message.error('请选择退回地址');
      }
      this.loading = true;
      (0, _order.orderAuditApi)({
        auditType: 'success',
        refundOrderNo: this.refundInfo.refundOrderNo,
        merAddressId: this.refundAddrId
      }).then(function (res) {
        _this.loading = false;
        _this.$message.success('审核成功');
        _this.$emit('onHandleSuccess');
      }).catch(function (err) {
        _this.loading = false;
      });
    },
    handleCancel: function handleCancel() {
      this.$emit('onHandleCancel');
    },
    // 列表
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      this.$store.dispatch('settings/getMerchantAddrList', this.refundInfo.merId).then(function (list) {
        _this2.addressList = list;
      }).finally(function () {
        _this2.listLoading = false;
      });
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    }
  }
};